import { ITemplateFilterParams } from '@/services/common';
import { create } from 'zustand';

type FilterParamsTypes = Partial<ITemplateFilterParams> & {
  group_code: string;
  module_list: string;
  status: 0 | 1 | 2 | '0,1,2' | undefined;
  size: number;
};

type FilterStore = {
  params: FilterParamsTypes;
  setParams: (newParams: Partial<FilterParamsTypes>) => void;
  resetParams: () => void;
};

const defaultParams: FilterParamsTypes = {
  group_code: 'DEFAULT_GROUP',
  module_list: 'SCENE,EXTRACTION,TABLE',
  status: '0,1,2',
  size: 50,
};

const useCustomFilterStore = create<FilterStore>((set) => ({
  params: defaultParams,
  setParams: (newParams) =>
    set((state) => ({
      params: {
        ...state.params,
        ...newParams,
      },
    })),
  resetParams: () => set({ params: defaultParams }),
}));

export default useCustomFilterStore;
